export const selectBlogs = (state) => state.blogs?.blogs;
export const selectCurrentBlog = (state) => state.blogs?.currentBlog;
export const selectBlogsLoading = (state) => state.blogs?.loading;
export const selectBlogError = (state) => state.blogs?.error;

export const selectCreateBlogLoading = (state) => state.blogs?.createLoading;
export const selectCreateBlogSuccess = (state) => state.blogs?.createSuccess;

export const selectUpdateBlogLoading = (state) => state.blogs?.updateLoading;
export const selectUpdateBlogSuccess = (state) => state.blogs?.updateSuccess;

export const selectDeleteBlogLoading = (state) => state.blogs?.deleteLoading;
export const selectDeleteBlogSuccess = (state) => state.blogs?.deleteSuccess;
